import { TextureLoader } from 'three';
export class ClTextureLoader {
    constructor() {
        this.cache = new Map();
        this.loader = new TextureLoader();
    }
    load(path, onProgress) {
        if (this.cache.has(path)) {
            return Promise.resolve(this.cache.get(path));
        }
        return new Promise((resolve, reject) => {
            this.loader.load(path, (texture) => {
                this.cache.set(path, texture);
                resolve(texture);
            }, onProgress, reject);
        });
    }
}
//# sourceMappingURL=TextureLoader.js.map